export default __webpack_public_path__ + "static/media/passLogo.254eb2fa.svg";